import { filter }              from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { Injectable }          from '@angular/core';

export interface DcpCrossWindowMessage {
  sourceWindowUuid: string;
  event: string;
  payload?: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class BroadCastService {
  private static currentDcpWindowUuid = crypto.randomUUID();

  broadcastChannel: BroadcastChannel;
  onMessage = new Subject<DcpCrossWindowMessage>();

  static getCurrentWinUuid(): string {
    return BroadCastService.currentDcpWindowUuid;
  }

  constructor() {
    const name: string = "DCP";
    this.broadcastChannel = new BroadcastChannel(name);
    this.broadcastChannel.onmessage = (message) => this.onMessage.next(message.data);
  }

  publish(event: string, payload?: unknown): void {
    const message: DcpCrossWindowMessage = {
      sourceWindowUuid: BroadCastService.currentDcpWindowUuid,
      event: event,
      payload: payload
    };
    this.broadcastChannel.postMessage(message);
  }

  messagesOfType(event: string): Observable<DcpCrossWindowMessage> {
    return this.onMessage.pipe(
      filter(message => message.event === event)
    );
  }
}
